import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import HcspDashboardComponent from './hcsp-dashboard-embed';

@NgModule({
    declarations: [
        HcspDashboardComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        TranslateModule,
        RouterModule
    ],
    providers: [

    ],
    exports: [
        HcspDashboardComponent
    ]
})

export class HcspDashboardModule {
}



// WEBPACK FOOTER //
// ./src/app/components/hcsp-dashboard/hcsp-dashboard.module.ts